import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { articles } from '@/mocks/seo-content';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 whitespace-nowrap">
                Sugargoo Spreadsheet
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                Independent resource website providing organized Sugargoo Spreadsheet product databases, shopping guides, and category navigation for informed shoppers.
              </p>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                Visit Main Platform
                <i className="ri-external-link-line"></i>
              </a>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 whitespace-nowrap">
                SEO Guides
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to={`/article/${articles[0].slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <Link to={`/article/${articles[1].slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    Shipping Guide
                  </Link>
                </li>
                <li>
                  <Link to={`/article/${articles[2].slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    Review & Safety
                  </Link>
                </li>
                <li>
                  <Link to={`/article/${articles[6].slug}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    Beginner Guide
                  </Link>
                </li>
                <li>
                  <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    Main Platform
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 whitespace-nowrap">
                Popular Categories
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4 whitespace-nowrap">
                More Categories
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(6, 12).map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2026 Sugargoo Spreadsheet Resource Hub. Independent resource website.
            </p>
            <div className="flex items-center gap-6 flex-wrap">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Privacy</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Terms</a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}